import React from "react";
import { getAnswers } from "actions/Monitoring";

/**
 * Custom hook para manejar la lógica de respuestas y preguntas
 */
export const useAnswers = () => {
  const [answers, setAnswers] = React.useState([]);
  const [click, setClick] = React.useState(false);

  const handleQuestions = (idResponseStage) => {
    setClick(false);
    getAnswers(idResponseStage).then((response) => {
      setAnswers(response);
    });
  };

  const handleOpenAll = (e) => {
    setClick(!click);
    e.currentTarget.classList.toggle("exp");
    e.currentTarget.classList.toggle("col");

    const details = document.querySelectorAll("details");

    Array.from(details).forEach(function (obj, idx) {
      if (e.currentTarget.classList.contains("exp")) {
        obj.open = true;
      } else {
        obj.removeAttribute("open");
      }
    });
  };

  const resetAnswers = () => {
    setAnswers([]);
    setClick(false);
  };

  return {
    answers,
    click,
    handleQuestions,
    handleOpenAll,
    resetAnswers,
  };
};
